import {
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
} from '@/features/manage/manageActions';
import { TransAlert } from '@/i18n/trans/alert';
import { useDispatch } from '@/store/utils';
import {
  getBookingNonTripOfferFulfillments,
  isTravelPassBooking,
} from '@/utils/booking';
import type { FindBookingValues } from '@/utils/zodSchema';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const useBookingSearch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useCallback(
    async ({ bookingNumber, email }: Partial<FindBookingValues>) => {
      if (!bookingNumber || !email) {
        toast.warning(<TransAlert i18nKey="bookingsSearchFailed" />);
        return;
      }

      try {
        const booking = await dispatch(
          getManageFlowBookingByNumberAndEmail({ bookingNumber, email })
        ).unwrap();

        if (booking) {
          const fulfillments = getBookingNonTripOfferFulfillments(booking);

          if (isTravelPassBooking(booking) && fulfillments.length) {
            await dispatch(
              getManageFlowTravelAccountsMap(fulfillments)
            ).unwrap();
          }

          navigate('/manage-booking/details');
        } else {
          toast.warning(<TransAlert i18nKey="bookingsSearchFailed" />);
        }
      } catch {
        // A not-found booking resolves to `null` (handled above); reaching here
        // means the lookup request itself failed (network / server error).
        // Surface it as a toast — important for the deep-link auto-submit path,
        // which has no user gesture to retry against.
        toast.warning(<TransAlert i18nKey="bookingsSearchFailed" />);
      }
    },
    [dispatch, navigate]
  );
};
